import React from 'react';
import { Box, Flex } from '@radix-ui/themes';
import NavBar from 'Components/element/NavBar';
import './2025-questionnaire.css';
export const Questionary2025 = () => {
  const url =
    'https://docs.google.com/forms/d/19i4CRIEzHCP0AkxIJLguN7kvULnZgD1eg80QR29Mcfk/viewform?edit_requested=true';
  return (
    <Flex className="Questionary2025" direction="column">
      <Box>
        <NavBar />
      </Box>

      <Flex className="iframe-container" width="100" height="calc(100vh - 80px)">
        <iframe src={url} width="100%" height="100%"></iframe>
      </Flex>
    </Flex>
  );
};
